export const isBareUrl = (value: string) =>
    (value.startsWith('http://') || value.startsWith('https://')) &&
    !/\s/.test(value);

export function remarkDisableIndentedCode(this: {
    data: () => { micromarkExtensions?: unknown[] };
}) {
    const data = this.data();
    data.micromarkExtensions = data.micromarkExtensions ?? [];
    data.micromarkExtensions.push({ disable: { null: ['codeIndented'] } });
}
